export const RESET = 'EXCMTASKTYPE_UPDATE_RESET'
export const SET_ERROR = 'EXCMTASKTYPE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMTASKTYPE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMTASKTYPE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMTASKTYPE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMTASKTYPE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMTASKTYPE_UPDATE_UPDATE_RETRIEVED'
